import FieldsInput from "../../../../components/FieldComponents/FieldsInput";
import { mergeClasses } from "@fluentui/react-components";
import Style from "../../../Client/ClientManagement/AddClient.style";
import { Stack } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import Layout from "../../../../styles/Layout.styles";
import FieldSelectPhoneCode from "../../../../components/FieldComponents/FieldSelectPhoneCode";
import { NUMBER_VALIDATION_16SIZE_PATTERN } from "../../../../utils/constants";
import { blockInvalidCharPhone } from "../../../../utils/blockInvalidCharPhone";

const UserPhoneNumber = (props) => {
  const { userPhoneNumber, userPhonePrefix } = props;
  const style = Style();
  const layout = Layout();
  const { t } = useTranslation();
  return (
    <>
      <Stack className={style.client_field}>
        <Stack className={layout.flex_row}>
          <FieldSelectPhoneCode
            name={userPhonePrefix}
            inputDefaultValue={userPhonePrefix ? userPhonePrefix : "+61"}
            className={mergeClasses(
              layout.clientContactPrefix,
              "clientContactPrefix",
              props?.errors?.userPhoneNumber ? "mb-1_5" : ""
            )}
            validation={props.register("userPhonePrefix")}
          />

          <FieldsInput
            label={t("phone_number")}
            validationMessage={props.errors?.userPhoneNumber?.message}
            id="userPhoneNumber"
            placeholder={t("enter_phone_number")}
            name="userPhoneNumber"
            // inputType="number"
            // onKeyDown={blockInvalidCharPhone}
            className="phoneNumberInput"
            inputDefaultValue={userPhoneNumber}
            inputClassName={mergeClasses(style.textboxInput)}
            validation={props.register("userPhoneNumber", {
              required: `${t("validation_message.phone_number_is_required")}`,
              pattern: {
                value: NUMBER_VALIDATION_16SIZE_PATTERN,
                message: `${t("validation_message.number_not_match16_format")}`,
              },
            })}
          />
        </Stack>
      </Stack>
    </>
  );
};

export default UserPhoneNumber;
